export default "__VITE_ASSET__DZjkXrRG__"